for (const elementName of ['clr-bookmark-strip', 'clr-product-slider']) {
 if (!customElements.get(elementName)) {
  customElements.define(elementName, class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('[data-strip-track]');
      const controls = this.querySelector('[data-strip-controls]');
      const previous = this.querySelector('[data-strip-previous]');
      const next = this.querySelector('[data-strip-next]');
      if (!track || !controls || !previous || !next) return;
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = maximum <= 1;
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maximum - 1;
      };
      const move = (direction) => {
        const card = track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      const back = () => move(-1);
      const forward = () => move(1);
      previous.addEventListener('click', back);
      next.addEventListener('click', forward);
      track.addEventListener('scroll', update, {passive: true});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();
      this.cleanup = () => {
        previous.removeEventListener('click', back);
        next.removeEventListener('click', forward);
        track.removeEventListener('scroll', update);
        observer.disconnect();
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
}
